class ThumbnailSliderNavigation {
  constructor() {
    this.init()
  }

  init() {
    // Find all media galleries with thumbnail slider layout
    const mediaGalleries = document.querySelectorAll(
      'media-gallery[data-desktop-layout*="thumbnail"]',
    )

    mediaGalleries.forEach(gallery => {
      this.setupNavigation(gallery)
    })

    // Also check for galleries that might be added dynamically
    if (mediaGalleries.length === 0) {
      // If no galleries found, try again after a short delay
      setTimeout(() => {
        const delayedGalleries = document.querySelectorAll(
          'media-gallery[data-desktop-layout*="thumbnail"]',
        )
        delayedGalleries.forEach(gallery => {
          this.setupNavigation(gallery)
        })
      }, 100)
    }
  }

  setupNavigation(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]')
    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]')
    const navigationButtons = viewer?.querySelector('.slider-buttons')

    if (!viewer || !thumbnails || !navigationButtons) {
      console.log('ThumbnailSliderNavigation: Missing required elements', {
        viewer: !!viewer,
        thumbnails: !!thumbnails,
        navigationButtons: !!navigationButtons,
      })
      return
    }

    const prevButton = navigationButtons.querySelector(
      'button[name="previous"]',
    )
    const nextButton = navigationButtons.querySelector('button[name="next"]')
    const currentCounter = navigationButtons.querySelector(
      '.slider-counter--current',
    )
    const totalCounter = navigationButtons.querySelector(
      '.slider-counter--total',
    )

    if (!prevButton || !nextButton) {
      console.log('ThumbnailSliderNavigation: Missing navigation buttons', {
        prevButton: !!prevButton,
        nextButton: !!nextButton,
      })
      return
    }

    // Get all media items and thumbnails
    const mediaItems = Array.from(viewer.querySelectorAll('[data-media-id]'))
    const thumbnailItems = Array.from(
      thumbnails.querySelectorAll('[data-target]'),
    )

    // Use the existing counter to get the correct total
    const existingTotal =
      parseInt(totalCounter.textContent) || thumbnailItems.length
    const totalItems = Math.min(existingTotal, thumbnailItems.length)

    if (totalItems <= 1) return

    let currentIndex = 0

    // Set initial state
    this.updateCounter(
      currentCounter,
      totalCounter,
      currentIndex + 1,
      totalItems,
    )
    this.updateButtonStates(prevButton, nextButton, currentIndex, totalItems)

    // Handle previous button click
    prevButton.addEventListener('click', e => {
      e.preventDefault()
      if (currentIndex > 0) {
        currentIndex--
        this.switchToMedia(mediaItems, thumbnailItems, currentIndex)
        this.updateCounter(
          currentCounter,
          totalCounter,
          currentIndex + 1,
          totalItems,
        )
        this.updateButtonStates(
          prevButton,
          nextButton,
          currentIndex,
          totalItems,
        )
      }
    })

    // Handle next button click
    nextButton.addEventListener('click', e => {
      e.preventDefault()
      if (currentIndex < totalItems - 1) {
        currentIndex++
        this.switchToMedia(mediaItems, thumbnailItems, currentIndex)
        this.updateCounter(
          currentCounter,
          totalCounter,
          currentIndex + 1,
          totalItems,
        )
        this.updateButtonStates(
          prevButton,
          nextButton,
          currentIndex,
          totalItems,
        )
      }
    })

    // Handle thumbnail clicks to update navigation state
    thumbnailItems.forEach((thumbnail, index) => {
      const button = thumbnail.querySelector('button')
      if (button) {
        button.addEventListener('click', () => {
          currentIndex = index
          this.updateCounter(
            currentCounter,
            totalCounter,
            currentIndex + 1,
            totalItems,
          )
          this.updateButtonStates(
            prevButton,
            nextButton,
            currentIndex,
            totalItems,
          )
        })
      }
    })

    console.log('ThumbnailSliderNavigation: Navigation setup complete', {
      totalItems,
      mediaItemsCount: mediaItems.length,
      thumbnailItemsCount: thumbnailItems.length,
      existingTotal: existingTotal,
      hasThumbnails: thumbnailItems.length > 0,
    })
  }

  switchToMedia(mediaItems, thumbnailItems, index) {
    // Remove active class from all media items
    mediaItems.forEach(item => {
      item.classList.remove('is-active')
    })

    // Remove active class from all thumbnails
    thumbnailItems.forEach(thumbnail => {
      const button = thumbnail.querySelector('button')
      if (button) {
        button.removeAttribute('aria-current')
      }
    })

    // Get the target media ID from the thumbnail at the current index
    if (index < thumbnailItems.length && thumbnailItems[index]) {
      const targetMediaId = thumbnailItems[index].getAttribute('data-target')

      // Find the corresponding media item
      const targetMediaItem = mediaItems.find(
        item => item.getAttribute('data-media-id') === targetMediaId,
      )

      // Add active class to the target media item
      if (targetMediaItem) {
        targetMediaItem.classList.add('is-active')
      }

      // Add active class to the current thumbnail
      const button = thumbnailItems[index].querySelector('button')
      if (button) {
        button.setAttribute('aria-current', 'true')
      }
    }
  }

  updateCounter(currentCounter, totalCounter, current, total) {
    if (currentCounter) {
      currentCounter.textContent = current
    }
    if (totalCounter) {
      totalCounter.textContent = total
    }
  }

  updateButtonStates(prevButton, nextButton, currentIndex, totalItems) {
    // Disable previous button if at first item
    if (currentIndex === 0) {
      prevButton.setAttribute('disabled', 'disabled')
    } else {
      prevButton.removeAttribute('disabled')
    }

    // Disable next button if at last item
    if (currentIndex === totalItems - 1) {
      nextButton.setAttribute('disabled', 'disabled')
    } else {
      nextButton.removeAttribute('disabled')
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ThumbnailSliderNavigation()
  })
} else {
  new ThumbnailSliderNavigation()
}

// Also initialize on Shopify section updates
document.addEventListener('shopify:section:load', () => {
  new ThumbnailSliderNavigation()
})
